import { render, staticRenderFns } from "./debug_tab_vue.vue?vue&type=template&id=2324996d&"
import script from "./debug_tab_vue.vue?vue&type=script&lang=js&"
export * from "./debug_tab_vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260414130119/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2324996d')) {
      api.createRecord('2324996d', component.options)
    } else {
      api.reload('2324996d', component.options)
    }
    module.hot.accept("./debug_tab_vue.vue?vue&type=template&id=2324996d&", function () {
      api.rerender('2324996d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/debug/debug_tab_vue.vue"
export default component.exports